import React, { useEffect, useRef } from 'react';

function GridBackground() {
  const svgRef = useRef(null);

  useEffect(() => {
    let animationFrame;
    const svg = svgRef.current;
    const width = window.innerWidth;
    const height = window.innerHeight;
    const cols = Math.floor(width / 60);
    const rows = Math.floor(height / 60);
    const points = [];
    for (let y = 0; y <= rows; y++) {
      for (let x = 0; x <= cols; x++) {
        points.push({
          x: x * 60 + 30 * Math.sin(y),
          y: y * 60 + 30 * Math.cos(x),
          baseX: x * 60,
          baseY: y * 60,
          phase: Math.random() * Math.PI * 2,
        });
      }
    }

    function animateGrid(time) {
      if (!svg) return;
      const t = time / 1000;
      let i = 0;
      for (let y = 0; y <= rows; y++) {
        for (let x = 0; x <= cols; x++) {
          const point = points[i];
          point.x = point.baseX + 18 * Math.sin(t + point.phase + y * 0.5);
          point.y = point.baseY + 18 * Math.cos(t + point.phase + x * 0.5);
          i++;
        }
      }
      // Atualiza os círculos
      const circles = svg.querySelectorAll('circle');
      i = 0;
      circles.forEach((circle) => {
        circle.setAttribute('cx', points[i].x);
        circle.setAttribute('cy', points[i].y);
        i++;
      });
      // Atualiza as linhas horizontais
      const hLines = svg.querySelectorAll('.h-line');
      for (let y = 0; y <= rows; y++) {
        for (let x = 0; x < cols; x++) {
          const idx1 = y * (cols + 1) + x;
          const idx2 = y * (cols + 1) + x + 1;
          const line = hLines[y * cols + x];
          line.setAttribute('x1', points[idx1].x);
          line.setAttribute('y1', points[idx1].y);
          line.setAttribute('x2', points[idx2].x);
          line.setAttribute('y2', points[idx2].y);
        }
      }
      // Atualiza as linhas verticais
      const vLines = svg.querySelectorAll('.v-line');
      for (let x = 0; x <= cols; x++) {
        for (let y = 0; y < rows; y++) {
          const idx1 = y * (cols + 1) + x;
          const idx2 = (y + 1) * (cols + 1) + x;
          const line = vLines[x * rows + y];
          line.setAttribute('x1', points[idx1].x);
          line.setAttribute('y1', points[idx1].y);
          line.setAttribute('x2', points[idx2].x);
          line.setAttribute('y2', points[idx2].y);
        }
      }
      animationFrame = requestAnimationFrame(animateGrid);
    }
    animationFrame = requestAnimationFrame(animateGrid);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  // Renderiza SVG inicial
  const width = typeof window !== 'undefined' ? window.innerWidth : 1200;
  const height = typeof window !== 'undefined' ? window.innerHeight : 800;
  const cols = Math.floor(width / 60);
  const rows = Math.floor(height / 60);
  const circles = [];
  const hLines = [];
  const vLines = [];
  for (let y = 0; y <= rows; y++) {
    for (let x = 0; x <= cols; x++) {
      circles.push(<circle key={`c-${x}-${y}`} cx={x * 60} cy={y * 60} r="2.5" fill="#00c6fb" opacity="0.18" />);
    }
  }
  for (let y = 0; y <= rows; y++) {
    for (let x = 0; x < cols; x++) {
      hLines.push(
        <line
          key={`h-${x}-${y}`}
          className="h-line"
          x1={x * 60}
          y1={y * 60}
          x2={(x + 1) * 60}
          y2={y * 60}
          stroke="#00c6fb"
          strokeWidth="1.2"
          opacity="0.10"
        />
      );
    }
  }
  for (let x = 0; x <= cols; x++) {
    for (let y = 0; y < rows; y++) {
      vLines.push(
        <line
          key={`v-${x}-${y}`}
          className="v-line"
          x1={x * 60}
          y1={y * 60}
          x2={x * 60}
          y2={(y + 1) * 60}
          stroke="#00c6fb"
          strokeWidth="1.2"
          opacity="0.10"
        />
      );
    }
  }

  return (
    <svg
      ref={svgRef}
      className="grid-background-svg"
      width="100%"
      height="100%"
      style={{ position: 'absolute', inset: 0, zIndex: 0, pointerEvents: 'none' }}
    >
      {hLines}
      {vLines}
      {circles}
    </svg>
  );
}

export default GridBackground; 